import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import mainReducer from './containers/Main/reducer';
import notesPageReducer from './containers/NotesPage/reducer';
import settingsReducer from './containers/Settings/reducer';
import templateReducer from './containers/Template/reducer';
import forgotPasswordReducer from './containers/ForgotPage/reducer';
import otpVerifyReducer from './containers/OtpVerifyPage/reducer';
import resetPasswordReducer from './containers/ResetPasswordPage/reducer';

const createAppReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    form: formReducer,
    main: mainReducer,
    notesPage: notesPageReducer,
    settings: settingsReducer,
    template: templateReducer,
    forgotPassword: forgotPasswordReducer,
    otpVerify: otpVerifyReducer,
    resetPassword: resetPasswordReducer,
  });

const createRootReducer = (history) => (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }
  return createAppReducer(history)(state, action);
};

export default createRootReducer;
